'use client'

// src/utils/saudiRedeems.ts
var convertPointsToCurrency = (points, conversions, userCurrency = "SAR") => {
  const conversion = conversions.find((item) => item.conversionName === userCurrency);
  if (!conversion) {
    return 0;
  }
  return conversion.conversionValue * points;
};
var convertCurrencyToPoints = (price, conversions, userCurrency = "SAR") => {
  const conversion = conversions.find((item) => item.conversionName === userCurrency);
  if (!conversion) {
    return 0;
  }
  return +(price / conversion.conversionValue).toFixed(2);
};

export {
  convertPointsToCurrency,
  convertCurrencyToPoints
};
//# sourceMappingURL=chunk-WETELLTX.mjs.map